"use client";

import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Imagine() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (window.innerWidth / 2 - e.clientX) / 40;
      const y = (window.innerHeight / 2 - e.clientY) / 40;
      setMousePosition({ x, y });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <section className="bg-white pt-20 pb-20 relative z-30">
      <div className="absolute inset-0 z-0 pointer-events-none opacity-95">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/images/formacao-devs-ia/Pixels.png" alt="" className="w-full h-full object-cover" />
      </div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-12 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="col-span-11 lg:col-span-5 relative z-20"
          >
            <h2 className="text-3xl md:text-5xl lg:text-[52px] font-bold text-blue-medium leading-[1.1] mb-6 tracking-tight">
              Imagine começar sua carreira tech em uma empresa listada na maior bolsa de valores do mundo.
            </h2>
            <p className="text-xl md:text-3xl font-bold text-blue-main mb-10">
              Aqui, isso é realidade!
            </p>
            <a
              href="https://job-boards.greenhouse.io/agibank/jobs/5270544008"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-secondary-main text-blue-dark px-10 py-4 rounded-full font-bold text-lg hover:bg-blue-main hover:text-white transition-all transform hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(119,223,64,0.3)]"
            >
              Vamos crescer juntos?
            </a>
          </motion.div>

          <div className="col-span-11 lg:col-span-7 relative flex justify-center items-center mt-20 lg:mt-0">
            <div className="relative w-[75%] max-w-[500px] aspect-square z-10 rounded-[32px] shadow-2xl">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src="/images/formacao-devs-ia/Imagine-Central.png"
                alt="Equipe Agibank"
                className="w-full h-full object-cover rounded-[32px]"
              />

              <motion.div
                whileHover={{ scale: 1.08, zIndex: 40 }}
                animate={{ x: mousePosition.x * 1.5, y: mousePosition.y * 1.5 }}
                transition={{ type: "spring", stiffness: 50, damping: 20 }}
                className="absolute -top-[20%] -left-[5%] w-[30%] aspect-square z-20 rounded-[24px] shadow-xl cursor-pointer"
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src="/images/formacao-devs-ia/Imagine-Pequena-1.png" alt="NYSE" className="w-full h-full object-cover rounded-[24px]" />
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.08, zIndex: 40 }}
                animate={{ x: mousePosition.x * -1, y: mousePosition.y * -1 }}
                transition={{ type: "spring", stiffness: 50, damping: 20 }}
                className="absolute -bottom-[20%] -left-[10%] w-[42%] aspect-square z-20 rounded-[24px] shadow-xl cursor-pointer"
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src="/images/formacao-devs-ia/Imagine-Pequena-2.png" alt="Palestrante" className="w-full h-full object-cover rounded-[24px]" />
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.08, zIndex: 40 }}
                animate={{ x: mousePosition.x * 1.2, y: mousePosition.y * 1.2 }}
                transition={{ type: "spring", stiffness: 50, damping: 20 }}
                className="absolute top-[40%] -right-[12%] w-[35%] aspect-square z-20 rounded-[24px] shadow-xl cursor-pointer"
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src="/images/formacao-devs-ia/Imagine-Pequena-3.png" alt="Jaqueta AGBK" className="w-full h-full object-cover rounded-[24px]" />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
